import sanitize from 'sanitize-html'

const textSanitizeConfig: sanitize.IOptions = {
  allowedTags: [],
  allowedAttributes: {},
}

const messageSanitizeConfig: sanitize.IOptions = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a'],
  allowedAttributes: {
    a: ['href'],
    b: ['data-contact-uri', 'contenteditable'],
  },
}

function unescapeToText (text: string) {
  return text.replace(/&amp;/g, '&').replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
}

export function sanitizeToText (html: string): string {
  return unescapeToText(sanitize(html, textSanitizeConfig))
}

export function sanitizeMessage (messageText: string): string {
  return sanitize(messageText, messageSanitizeConfig)
}
